import { create } from "zustand";

type UploadStatusStore = {
  isUploading: boolean;
  setIsUploading: (value: boolean) => void;
};

export const useUploadStatusStore = create<UploadStatusStore>((set) => ({
  isUploading: false,
  setIsUploading: (value) => set({ isUploading: value }),
}));
